<template>
  <div>
    <vs-prompt @cancel="closePrompt" @accept="finishEdit" :active.sync="isPromptActiveLocal"
    title="Editar venta">




          <vs-select class="mx-auto mt-3" label="Tiempo de recepcion" v-model="newSale.receptionTime">
            <vs-select-item :value="(halfhour-1)*30" :text="showRange((halfhour-1)*30)" v-for="halfhour in 48" :key="halfhour" />
          </vs-select>

          <vs-input class="mx-auto mt-3" label="Fecha de recepcion" v-model="newSale.receptionDate" type="date"/>

          <vs-input class="mx-auto mt-3" label="Prediccion de pago" v-model="newSale.paymentPrediction"/>

          <div class="mx-auto mt-3 vs-component vs-con-input-label vs-input vs-input-primary">
            <label for="" class="vs-input--label">Tipo de pago</label>
            <vs-row>
              <vs-col vs-w="12" v-for="(saleType, key) in dataDB.SalePaymentTypeIDs" :key="key">
                <vs-radio v-model="newSale.paymentTypeID" vs-name="tipopago" :vs-value="saleType">{{key}}</vs-radio>
              </vs-col>
            </vs-row>
          </div>



          <!-- <div class="con-exemple-prompt">
        Enter the security code
        <vs-input placeholder="Code" v-model="val"/>

        <vs-select
          class="selectExample"
          label="Figuras"
          v-model="select1"
          >
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in options1" />
        </vs-select>
      </div> -->


    </vs-prompt>
  </div>
</template>

<script>
  export default {
    props: {
      isPromptActive: { type: Boolean, required: true, },
      Sale: { type: Object, required: true, },
    }, // PROPS

    data() {
      return {
        newSale: {},
      }
    }, // DATA

    computed: {
      isPromptActiveLocal: {
        get() {
          return this.isPromptActive;
        },
        set(val) {
          this.closePrompt();
        }
      },
    }, // COMPUTED

    methods: {
      closePrompt() {
        this.$emit('closePrompt');
      },
      finishEdit() {
        try {
          let Params = {
            saleID: this.newSale.id,
            receptionTime: this.newSale.receptionTime,
            receptionDate: this.newSale.receptionDate,
            paymentPrediction: this.newSale.paymentPrediction,
            paymentTypeID: this.newSale.paymentTypeID,
          };
          // console.log("NewSale:", this.newSale.paymentTypeID)
          // console.log("Sale:", this.Sale.paymentTypeID)
          this.updateSale()
          this.$emit('modifySale', Params);
          this.myNotify('success', 'Exíto', 'Venta modificada!')
          // console.log("NewSale:", this.newSale.paymentTypeID)
          // console.log("Sale:", this.Sale.paymentTypeID)
        } catch (error) {
          this.myNotify('danger', 'Error', 'Un error ha ocurrido!')
          // console.log(error)
        }
      },
      updateSale() {
        // Actualiza la data de Sale sin hacer un request a la API
        this.Sale.receptionTime = this.newSale.receptionTime
        this.Sale.receptionDate = this.newSale.receptionDate
        this.Sale.paymentPrediction = this.newSale.paymentPrediction
        this.Sale.paymentTypeID = this.newSale.paymentTypeID
      }
    },
    updated() {
      //Deslinkea newSale con Sale
      if (this.newSale.id != this.Sale.id) {
        this.newSale = {
          ...this.Sale
        }
      }
    },
  } // export default

</script>

<style lang="css" scoped>

</style>
